import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    error: null,
    createdData: {},
    createPostLoader: false,
    postCreatedSuccess: false,
    createPostModal: false,
    removePostPass: null,
    removePostId: null,

    isPostLikeSuccess: null,
    lastCommentData: null
};

const community = createSlice({
    name: 'community',
    initialState,
    reducers: {
        createPostLoad: (state) => {
            state.createPostLoader = true
            state.postCreatedSuccess = false

        },
        toxicPostLoad :(state , action) => {
            state.postCreatedSuccess = false
        },
        createPostSuccess: (state, action) => {
            state.createPostLoader = false
            state.postCreatedSuccess = true
            state.createPostModal = false
            state.createdData = action.payload
        },
        createPostFail: (state) => {
            state.createPostLoader = false
            state.postCreatedSuccess = false
        },
        createPostModalHandler: (state) => {
            state.createPostModal = !state.createPostModal
        },
        removePostload: (state) => {
            state.removePostPass = false
        },

        removePostSuccess: (state, action) => {
            state.removePostPass = true;
            state.removePostId = action.payload
        },

        postLikeLoad: (state) => {
            state.isPostLikeSuccess = false;
        },
        postLikeSuccess: (state, action) => {
            state.isPostLikeSuccess = true;
            state.lastCommentData = action.payload
        },
        postLikeFail: (state, action) => {
            state.isPostLikeSuccess = false;
            state.lastCommentData = null
        },
    }
});

export const {
    createPostLoad,
    createPostSuccess,
    createPostFail,
    createPostModalHandler,
    removePostSuccess,
    removePostload,
    postLikeLoad,
    postLikeSuccess,
    postLikeFail,
    toxicPostLoad

} = community.actions;

export default community.reducer;
